var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconTargetgroupCompanies24 = function SvgAIconTargetgroupCompanies24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4426 9.42517H11.7536C12.2936 9.42517 12.7313 9.8443 12.7313 10.3613V22.0632H2.46484V10.3613C2.46484 9.8443 2.9026 9.42517 3.4426 9.42517Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6644 22.0634H21.531V2.40423C21.531 1.6287 20.8743 1 20.0643 1H11.2645C10.4545 1 9.79785 1.6287 9.79785 2.40423V6.61692H11.2645",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46664 22.0638H1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5332 22.0638H22.9998",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79785 3.80811H14.1978",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46484 12.2341H4.6648",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33367 22.063H5.40039V19.2545C5.40039 18.479 6.05703 17.8503 6.86703 17.8503C7.67703 17.8503 8.33367 18.479 8.33367 19.2545V22.063Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5993 22.0627H15.666V17.85C15.666 17.0745 16.3227 16.4458 17.1327 16.4458C17.9427 16.4458 18.5993 17.0745 18.5993 17.85V22.0627Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconTargetgroupCompanies24 as ReactComponent };
export default "data:image/svg+xml;base64,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";